// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2AN9T","right":"Footer_right__FmoPL","buttons":"Footer_buttons__1Y8ET"};